// extracted by mini-css-extract-plugin
module.exports = {"Definition":"DefinitionList_Definition___KT58","Key":"DefinitionList_Key__6M7hf","Value":"DefinitionList_Value___iVcZ"};